import React, { FC } from 'react'

import { UseFormRegisterReturn } from 'react-hook-form'

import { Txt, TextField } from 'src/components/atoms'

import { SamlIdpFormEntity } from 'src/types'

/**
 * Note: Prefixに与えた値が文字列リテラルTの接頭辞として設定される
 *   @example
 *   type t = "specific-key" | "another-key"
 *   type f = PrefixKeys<t, 'test'>
 *   => "test.specific-key" | "test.another-key"
 */
type PrefixKeys<T extends string, Prefix extends string> = {
  [K in T]: `${Prefix}.${K}`
}[T]

type Props = {
  // SamlIdpFormEntityのattributeMappingで定義されているキーのみを受け付ける
  register: UseFormRegisterReturn<
    PrefixKeys<keyof SamlIdpFormEntity['attributeMapping'], 'attributeMapping'>
  >
  attribute: string
  placeholder?: string
  required?: boolean
  className?: string
}

export const AttributeMappingInputItem: FC<Props> = ({
  register,
  attribute,
  placeholder,
  required = false,
  className,
}) => {
  return (
    <div className={className}>
      <div className="tw-flex tw-gap-r2">
        <TextField disabled placeholder={attribute} className="tw-w-[17rem]" />
        <div className="tw-flex tw-items-center">
          {required && (
            <Txt
              sizeType="s"
              className="tw-bg-errorRed-default tw-text-inlineText-primary tw-px-s-2 tw-h-[1.3rem] tw-centering tw-font-bold tw-mr-s-2"
            >
              必須
            </Txt>
          )}
          <TextField placeholder={placeholder} {...register} className="tw-w-[17rem]" />
        </div>
      </div>
    </div>
  )
}
